/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Outcome_DescriptionInputs */

const en_directory_submit_outcome_description = /** @type {(inputs: Directory_Submit_Outcome_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your entry begins in editorial review. Once it is live, you can manage its details from My tools.`)
};

const zh_directory_submit_outcome_description = /** @type {(inputs: Directory_Submit_Outcome_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交后会进入编辑审核。发布后，你可以在“我的工具”中管理资料详情。`)
};

/**
* | output |
* | --- |
* | "Your entry begins in editorial review. Once it is live, you can manage its details from My tools." |
*
* @param {Directory_Submit_Outcome_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_outcome_description = /** @type {((inputs?: Directory_Submit_Outcome_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Outcome_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_outcome_description(inputs)
	return zh_directory_submit_outcome_description(inputs)
});
export { directory_submit_outcome_description as "directory.submit.outcome_description" }